module.exports = __webpack_public_path__ + "static/media/fa-thin-100.d6b811b6.ttf";